<app-fil-ariane-v2></app-fil-ariane-v2>
<div class="maincontainer background-color pb-4">
    <div class="mt-4">
        <app-event-add-form></app-event-add-form>
    </div>
</div>